import { FlowType } from '@domain/types';
import { createAction, PayloadAction } from '@reduxjs/toolkit';

import { desktopSlice } from './desktop.reducer';

export type MoveFilePayload = { filePath: string; flowType: FlowType };
export type MoveFileAction = PayloadAction<MoveFilePayload>;

export const DesktopActions = {
  ...desktopSlice.actions,

  moveImportedFileToSuccess: createAction<MoveFilePayload>(
    `${desktopSlice.name}/moveImportedFileToSuccess`,
  ),

  moveNonImportedFileToError: createAction<MoveFilePayload>(
    `${desktopSlice.name}/moveNonImportedFileToError`,
  ),

  showOutboxErrorFolder: createAction<{ fileName?: string; type: FlowType }>(
    `${desktopSlice.name}/showOutboxErrorFolder`,
  ),
  initDesktop: createAction<void>(`${desktopSlice.name}/initDesktop`),
};
